export default __webpack_public_path__ + "static/media/gops-inspection-intro-img.6248fd8d.webp";